export default __webpack_public_path__ + "static/AntIcon200-cb5669b32a8376334020780fc684862c.png";